<template>
  <el-dialog :visible.sync="dialogVisible" class="reset-password-container reset-password-container-box"
             :title="$t('operations.reset_password.name')"
             size="default" :close-on-click-modal="false" :before-close="doClose">
    <div class="i-text tip-style">
      <div class="tip-warning">
        {{ $t('passwordReset.sentence') }}
      </div>
    </div>
    <el-form ref="ruleForm" label-width="90px" :model="ruleForm" :rules="rules" class="form-style">
      <!--实例名称-->
      <el-form-item :label="$t('listPage.text.exampleName') | withColon">
        <span class="reinstall-tip">{{detailData.name | maybeEmpty}}</span>
      </el-form-item>
      <!--实例ID-->
      <el-form-item :label="$t('privateNetInstance.instanceID') | withColon">
        <span>{{detailData.instanceId | maybeEmpty}}</span>
      </el-form-item>
      <!--新密码-->
      <el-form-item :label="$t('passwordReset.newPassword')|withColon" required prop="newPassword"
                    :show-message="false" ref="newPassword">
        <el-input style="width:500px;" v-model="ruleForm.newPassword"
                :type="newPasswordVisible ? 'text' : 'password'"
                  auto-complete="off">
                <!-- 小眼睛图标，点击切换显隐 -->
                <i slot="suffix"
                    class="el-input__icon el-icon-view"
                    :style="{ color: newPasswordVisible ? '#409EFF' : '#c0c4cc' }"
                    @click="newPasswordVisible = !newPasswordVisible"></i>
                </el-input>
        <p class="el-form-item-help color-gray"
           :class="{'el-form-item-help-error': ruleFormTag.newPassword === 'error'}">
          {{$t('create.help.password')}}
        </p>
      </el-form-item>
      <!--确认密码-->
      <el-form-item :label="$t('create.text.passwordConfirm')|withColon" required prop="newPasswordConfirm">
        <el-input style="width:500px;" v-model="ruleForm.newPasswordConfirm"
            :type="confirmPasswordVisible ? 'text' : 'password'"
                  auto-complete="off">
                    <!-- 小眼睛图标，点击切换显隐 -->
                    <i slot="suffix"
                        class="el-input__icon el-icon-view"
                        :style="{ color: confirmPasswordVisible ? '#409EFF' : '#c0c4cc' }"
                        @click="confirmPasswordVisible = !confirmPasswordVisible"></i>
                </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="doClose">
        {{ $t('listPage.text.cancelButton') }}
      </el-button>
      <el-button type="primary" @click="doConfirm()">
        {{ $t('listPage.text.sureButton') }}
      </el-button>
    </span>
  </el-dialog>
</template>


<script>
  import {ChargeModeMap, CreateTypeConstant, PasswordRuleConstant} from '../../../common/Constants';

  export default {
    data() {
      // 新密码验证validator
      const validatePassword = (rule, value, callback) => {
        if (value === '') {
            //   callback(new Error(this.$t('create.placeholder.passNull')))
            callback(new Error())
        } else {
          // 密码校验规则(8-30个字符，且同时包含三项（大写字母，小写字母，数字或特殊符号()`~!@#$%&*_-+=|{}[]:";'<>,.?/）。)
          const rule = PasswordRuleConstant
          if (this.ruleForm.newPasswordConfirm !== '') {
            this.$refs.ruleForm.validateField('newPasswordConfirm')
          }
          const result = rule.test(value)
          if (!result) {
            //callback(new Error(this.$t('create.placeholder.passNotMeetRequire')));
            callback(new Error())
          }
          callback();
        }
        this.ruleFormTag.newPassword = this.$refs.ruleForm.validateState
      }
      const validatePasswordConfirm = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('create.placeholder.confirmPassNull')))
        } else if (value !== this.ruleForm.newPassword) {
          callback(new Error(this.$t('create.placeholder.passNotSame')))
        } else {
          callback();
        }
      }
      return {
        ruleForm: {
          // 新密码
          newPassword: '',
          // 确认密码
          newPasswordConfirm: ''
        },
        ruleFormTag: {
          newPassword: 'valid',
        },
        rules: {
          newPassword: [
            {validator: validatePassword, trigger: 'blur'}
          ],
          newPasswordConfirm: [
            {validator: validatePasswordConfirm, trigger: 'blur'}
          ]
        },
        clientToken: Normal.getClientToken(),
        // 新密码显示状态，默认为 false（隐藏）
        newPasswordVisible: false,
        // 确认密码显示状态，默认为 false（隐藏）
        confirmPasswordVisible: false,
      };
    },
    computed: {
      CreateTypeConstant: () => CreateTypeConstant,
    },
    props: {
      dialogVisible: {
        type: Boolean,
        default: false,
      },
      detailData: {
        type: Object,
      }
    },
    watch: {},
    methods: {
      // 关闭弹框
      doClose() {
        this.resetInitParams();
        // 重置密码显示状态
        this.newPasswordVisible = false;
        this.confirmPasswordVisible = false;
        this.$emit('update:dialogVisible', false);
      },
      // 点击确认按钮，重置密码
      doConfirm() {
        this.$refs.ruleForm.validate((valid) => {
          if (!valid) {
            return false
          } else {
            this.resetPassword();
          }
        })
      },
      resetInitParams() {
        this.$refs.ruleForm.resetFields();
      },
      resetPassword() {
        const param = {
          region: this.detailData.region, // 区域
          createType: CreateTypeConstant.EIP,
          instanceId: this.detailData.instanceId,
          password: this.ruleForm.newPassword,
          clientToken: Normal.getClientToken(),
        };
        Ajax.put('/api/cps/resetPassword', param)
          .then(() => {
            this.doClose();
            this.$emit('refreshData')
          })
          .catch(async (err) => {
            const {response} = err.data;
            try {
              const json = await response.json();
              this.$message.error(json.errmsg);
            } catch (ex) {
              console.log(ex);
            }
          });
      },
    },
    mounted() {
    }
  };
</script>

<style lang="scss" scoped>
.reset-password-container-box {
    // 优化密码框高度
  .el-form-item.is-success.is-required {
      margin-bottom: 0!important;
      height: 81px!important;
    }
    .el-form-item.is-required {
      margin-bottom: 0!important;
      height: 81px!important;
    }
    
    .el-form-item.is-error.is-required {
        margin-bottom: 0!important;
        height: 81px!important;
    }
    .el-form-item__error:first {
        display: none!important;
    }
    // .el-form-item {
    //     height: 81px!important; 
    // }
    /* 密码框小眼睛 */
    .el-input__icon.is-active {
      color: #409eff;
    }
}
</style>

<style lang="scss" scoped>
  .reset-password-container{
    .form-style {
      margin-top: 20px;
      margin-left: 20px
    }

    .color-gray {
      color: #9e9e9e
    }

    .tip-style {
      width: 90%;
      margin: auto
    }

    .reinstall-tip{
      width:100%;
      text-align:center;
      word-break: break-word;
    }

    

    
  }
  
</style>



// WEBPACK FOOTER //
// src/components/common/resetPassword/ResetPassword.vue